const updates = {
  viewtitle: 'Updates',
  searchterm: 'Extension name',
  sitename: 'Site Name',
  extension: 'Extension Name',
  currentversion: 'Current Version',
  nextversion: 'Next Version',
  action: '',
  updateall: 'Update all',
  updateallonpage: 'Update listed',
  updateselected: 'Update selected',
  update: 'Update',
  extensionupdatefaileddoitagain: 'Failed! Again?',
  noitems: 'No updates',
  sitefilter: 'Select Site',
  fetchdata: 'Fetching Data'
}

export default updates
